module.exports = __webpack_public_path__ + "img/error-img.c7ae99ce.png";